import {
    CONSTRUCTOR_SECTION_ICON_COMPONENT_MAP,
    CONSTRUCTOR_SECTION_ICON_MAP_ACTIVE,
    CONSTRUCTOR_SECTION_ICON_MAP_HIDDEN,
} from '../icons';

export const getConstructorSectionIcon = (widget?: string) =>
    CONSTRUCTOR_SECTION_ICON_MAP_ACTIVE[widget ?? 'default'] ?? CONSTRUCTOR_SECTION_ICON_MAP_ACTIVE.default;

export const getConstructorSectionHiddenIcon = (widget?: string) =>
    CONSTRUCTOR_SECTION_ICON_MAP_HIDDEN[widget ?? 'default'] ?? CONSTRUCTOR_SECTION_ICON_MAP_HIDDEN.default;

export const getConstructorSectionIconComponent = (widget?: string) =>
    CONSTRUCTOR_SECTION_ICON_COMPONENT_MAP[widget ?? 'default'] ?? CONSTRUCTOR_SECTION_ICON_COMPONENT_MAP.default;
